
            const data = {"name":"home","data":{"width":"16","height":"17","viewBox":"0 0 16 17","data":"<path pid=\"0\" d=\"m1 6.5 7-5 7 5v9h-4v-5H5v5H1v-9Z\" _fill=\"#41A5DD\"/>","originalColors":[{"type":"fill","color":"#41A5DD"}],"stopColors":[]}}
        
                    module.exports = data
                    